import { RoutePaths } from 'config/route-paths';

export const POST_LOGIN_REDIRECT_PATH_KEY = 'postLoginRedirectPath';

const EXCLUDED_REDIRECT_PATHS = new Set<string>([
  RoutePaths.LOGIN,
  RoutePaths.LOGOUT,
  RoutePaths.INIT,
  RoutePaths.CALLBACK,
  RoutePaths.UNAUTHORIZED,
  RoutePaths.ROOT,
]);

/**
 * Only allow same-origin relative paths to avoid open-redirect attacks.
 */
export const isSafeInternalRedirectPath = (path: string): boolean => {
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('://') || path.includes('\\')) {
    return false;
  }

  const pathname = path.split(/[?#]/)[0] || RoutePaths.ROOT;
  return !EXCLUDED_REDIRECT_PATHS.has(pathname);
};

export const setPostLoginRedirectPath = (path: string): void => {
  if (!isSafeInternalRedirectPath(path)) return;
  localStorage.setItem(POST_LOGIN_REDIRECT_PATH_KEY, path);
};

export const getPostLoginRedirectPath = (): string | null => {
  const path = localStorage.getItem(POST_LOGIN_REDIRECT_PATH_KEY);
  if (!path || !isSafeInternalRedirectPath(path)) {
    return null;
  }
  return path;
};

export const clearPostLoginRedirectPath = (): void => {
  localStorage.removeItem(POST_LOGIN_REDIRECT_PATH_KEY);
};

export const consumePostLoginRedirectPath = (): string | null => {
  const path = getPostLoginRedirectPath();
  clearPostLoginRedirectPath();
  return path;
};
